import { useMemo } from 'react';

import {
  ChakraCircle,
  ChakraFlex,
  ChakraGridItem,
  ChakraText,
  EquipUIFireflyV2Theme,
  EquipUITheme,
  Menu,
  MenuOption,
  UpDownArrow,
} from '@equip.health/ui';

import { useGetObservationInterpretationsEnumQuery } from '~/store/services/enumerations';

import {
  GridItemProps,
  patientVitalsAbnormalInterpretations,
  patientVitalsNAInterpretation,
} from '../../constants';

const { primary } = EquipUIFireflyV2Theme.colors;
const { labelBold } = EquipUITheme.typography;

const GoalStatusGridItem = ({
  colSpan,
  id,
  isEditing,
  onChange,
  value,
}: GridItemProps<string>) => {
  const {
    data: observationInterpretations,
    isLoading: isGetObservationIntepretationsLoading,
  } = useGetObservationInterpretationsEnumQuery();

  const interpretationOptions = useMemo<MenuOption[]>(
    () =>
      (observationInterpretations ?? [])
        .map(({ interpretation }: { interpretation: string }) => ({
          node: interpretation,
          value: interpretation,
        }))
        .sort((a, b) => a.value.localeCompare(b.value)),
    [observationInterpretations?.length],
  );

  const isOutsideGoal = patientVitalsAbnormalInterpretations.includes(value);
  const goalStatusColor = isOutsideGoal ? 'critical.base' : 'success.base';

  return (
    <ChakraGridItem colSpan={colSpan} id={`${id}__interpretation-item`}>
      {isEditing ? (
        <Menu
          buttonContent={value}
          buttonSize="sm"
          icon={<UpDownArrow fill={primary[100]} height="15px" width="12px" />}
          id={`${id}__interpretation`}
          isFullWidth
          isLoading={isGetObservationIntepretationsLoading}
          onSelect={onChange}
          options={interpretationOptions}
          placeholder="Select..."
          textAlign="left"
        />
      ) : (
        value &&
        value !== patientVitalsNAInterpretation && (
          <ChakraFlex align="center">
            <ChakraCircle background={goalStatusColor} size="6px" />
            <ChakraText
              {...labelBold}
              color={goalStatusColor}
              id={`${id}__goal-status`}
              paddingLeft="8px"
            >
              {`${isOutsideGoal ? 'Outside' : 'Inside'} goal`}
            </ChakraText>
          </ChakraFlex>
        )
      )}
    </ChakraGridItem>
  );
};

export default GoalStatusGridItem;
